export default "__VITE_ASSET__d247758e__"